export const locale = {
    lang: 'en',
    data: {
      'CONFIGURACION': {
        'CABECERA':{
          'TITULO': 'SETTINGS',
          'DESCRIP': ''
        },
        'BOTONES':{
          'BOT1':{
            'TITULO': 'Upload collaborators database',
            'BOTON': 'Set'
          },
          'BOT2':{
            'TITULO': 'Upload company logo',
            'BOTON': 'Set'
          },
          'BOT3':{
            'TITULO': 'Technical requirements information',
            'BOTON': 'See more'
          }
        },
        'BD':{
          'TITUHEAD': 'Upload collaborators database',
          'INFO': 'Upload your company collaborators database into the system',
          'BOTONES':{
            'DescTemp': 'Download template'
          },
          'MENSAJES':{
            'CARGABD': 'Upload BD',
            'STATUS': 'STATUS',
            'CORRECTO': 'The database was uploaded successfully',
            'ERROR': 'An error ocurred in the upload process'
          }
        },
        'LOGO':{
          'TITUHEAD': 'Upload company logo',
          'INFO': 'Upload your company logo image',
          'MENSAJES':{
            'CARGABD': 'Upload logo image',
            'STATUS': 'STATUS',
            'CORRECTO': 'The logo was uploaded successfully',
            'ERROR': 'An error ocurred in the upload process'
          }
        },
        'REQTEC':{
          'TITUHEAD': 'Technical requirements information',
          'INFO': 'Platform requirements to ensure optimal functionality',
          'MENSAJES':{
            'CARGA': '',
            'STATUS': 'STATUS',
            'CORRECTO': 'Uploaded successfully',
            'ERROR': 'An error ocurred in the upload process'
          }
        }
      }
    }
};
